/**
 * Estados de un email enviado
 * Representa el tracking completo del ciclo de vida de un correo electrónico
 * 
 * Referencia: dripping-module.md líneas 84-91
 */
export enum EmailStatusEnum {
  /** Email enviado exitosamente */
  SENT = 'SENT',
  
  /** Email entregado al destinatario */
  DELIVERED = 'DELIVERED',
  
  /** Email abierto por el destinatario */
  OPENED = 'OPENED',
  
  /** Link del email clickeado */
  CLICKED = 'CLICKED',
  
  /** Email rebotado (no entregado) */
  BOUNCED = 'BOUNCED',
  
  /** Fallo al enviar el email */
  FAILED = 'FAILED'
}
